export default __webpack_public_path__ + "static/media/icon-tools.6ab2928a.png";